import { render, staticRenderFns } from "./HomeTestDia.vue?vue&type=template&id=7a4c30b1&scoped=true&"
import script from "./HomeTestDia.vue?vue&type=script&lang=ts&"
export * from "./HomeTestDia.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTestDia.vue?vue&type=style&index=0&id=7a4c30b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4c30b1",
  null
  
)

export default component.exports